import { Card, Col, Row, Container } from "reactstrap";
import { GalleryTitle, ImageHoverEffects } from "../../../Constant";
import { Breadcrumbs } from "../../../AbstractElements";
import CommonCardHeader from "../../../Common/CommonCardHeader";
import { HOVER_DATA } from "../../../Data/Gallery";
import { ImageHoverEffectsCardBody } from "./ImageHoverEffectsCardBody";

const ImageHoverEffectsContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={ImageHoverEffects} parent={GalleryTitle} title={ImageHoverEffects} />
      <Container fluid>
        {HOVER_DATA.map((data, index) => (
          <Row key={index}>
            <Col sm="12">
              <Card>
                <CommonCardHeader title={`Hover Effect ${data}`} />
                <ImageHoverEffectsCardBody data={data}/>
              </Card>
            </Col>
          </Row>
        ))}
      </Container>
    </>
  );
};

export default ImageHoverEffectsContainer;
